import { setTranslations, setLocale } from "react-i18nify";

var translations = {
  en: {
    application: {
      title: "Awesome app with i18n!",
      hello: "Hello, %{name}!",
      welcome: "Welcome, %{name}!",
      thanks: "Thanks, %{name}!",
      next: "next",
      back: "Back",
      end: "End",
      no: "No",
      yes: "Yes",
      close: "Close",
      continue: "Continue",
      success: "Success",
      options: {
        androidpluginunavailable: "Android Plugin Unavailable",
        epsonprinterpluginunavailable: "Epson Printer Plugin Unavailable",
        invalidcode: "Invalid Code",
        toomanyrequest: "Please re-try in a minute"
      },
      errors: {
        serverunavailable: "Server temporarily unavailable.",
        webaccessdisabled: "Web access is disabled.",
        unknownerror: "An Unknown Error has occurred.",
        invalidcredentials: "Invalid credentials provided.",
        toomanyrequests:
          "Too many incorrect requests. Please try again in a minute."
      },
      kioskdetail: {
        youareat: "You are at %{name} located on %{address}",
        youareatV: "You are located at %{address}",
        returningnumbags_1: "You are returning %{count} bag.",
        returningnumbags: "You are returning %{count} bags.",
        returningnumlabels_1: "You are printing %{count} sticker.",
        returningnumlabels: "You are printing %{count} stickers.",
        returning: "You are returning ",
        numbags_1: "%{count} bag",
        numbags: "%{count} bags",
        print: "printing",
        numlabels_1: "%{count} label",
        numlabels: "%{count} labels",
        errors: {
          unabletoprocesskey:
            "An error occurred while processing your Kiosk Key.",
          keyerror:
            "An error occurred while processing your Kiosk Key. Please check your Kiosk Key."
        }
      },
      configuration: {
        configuration: "Configuration",
        donthavekioskkey: "Don't have a Kiosk Key?",
        enterkey: "Please enter the kiosk key to start",
        printerdebug: "Printer Debug",
        confirmlogginginas: "You are registering this device to:",
        warning: "Warning",
        confirmchangecollectorwarning:
          "This device was previously registered to ",
        confirmisthiscorrect: "Is this correct?",
        versionmismatch: "Software Update Required",
        versionmismatchwarning:
          "The installed kiosk app (v%{currentversion}) is outdated. The latest version is v%{latestversion}. Please update before continuing, or tap 'Continue' to proceed without updating."
      },
      languageselect: {
        kioskname: "Bag Deposit Kiosk",
        presstostart: "Press here to start",
        selectlanguage: "Please select a Language:",
        english: "English",
        french: "Français",
        quickstart: "Quick Start",
        scanwithapp:
          "Quickly authenticate by scanning the QR code with the Consignaction App."
        // scanwithapp:
        //   "Scan the QR code using the Consignaction app to get started"
      },
      adminoptions: {
        kioskid: "KioskID",
        androidid: "AndroidID",
        testtheme: "Test Theme",
        printercut: "Printer Cut",
        accesscoderequired: "Access Code Required",
        instructions: "Enter administrator code",
        optionmenutitle: "Kiosk Options Menu"
      },
      phonenumber: {
        enterphonenumber: "Enter your Phone Number",
        pleasesignin: "Log in with your phone number",
        welcome: "Welcome!",
        donthaveaccount: "Don't have an account?",
        signinwithphone: "Sign in with phone number",
        scanqr: "Scan QR code to register",
        returnfor: "You are returning containers for:",
        isthiscorrect: "Is this correct?",
        urllangextension: "?lang=en",
        enterslowly: "Please enter your number slowly",
        errors: {
          unablefetchaccount: "An error occurred while fetching your account.",
          invalidphone: "Invalid telephone number. Please try again."
        }
      },

      numberofbags: {
        selectnumbags: "How many bags are you returning?",
        havemorebags: "Do you have more than %{count} bags?",
        multipleinteractions:
          "Yes. You will need to make more than one transaction.",
        needonlybags: "Do you just need stickers?",
        selectzerobags: "Yes. Please select 0 bags."
      },
      numberoflabels: {
        instructions: "To ensure you are credited, attach a label to each bag.",
        selectnumlabels: "How many stickers do you want to print?",
        bagsalreadylabelled: "Are all your bags identified?",
        selectzerobags: "Yes. Please select 0.",
        cantakelabelshome: "Can you take labels home?",
        uselabelsnexttime: "Yes, use them next time to speed up the drop."
      },
      submissionapproval: {
        title: "Hold Tight — Staff Required",
        instructions_1:
          "A manager must approve your return of %{count} bag before continuing.",
        instructions:
          "A manager must approve your return of %{count} bags before continuing.",
        errors: {
          overridekeyerror:
            "Invalid code. Please verify your code and try again."
        }
      },
      printing: {
        printing: "Labels are currently printing",
        readytoprint: "Ready to Print",
        taptoprint: "Press here to Print"
      },
      printererror: {
        title: "Printer Error",
        notconnected:
          "Printer disconnected. Please have a clerk check the power and cable connection.",
        coveropen:
          "Printer cover open. Ask a clerk to close it to resume printing.",
        generalerror:
          "Printer error detected. Please have a clerk check labels and reload if needed.",
        recheckbutton: "Recheck"
      },
      thankyou: {
        thankyou: "Thank You.",
        seeyouagain: "We hope to see you again, %{name}!",
        labelyourbags: "Identify your bags",
        attachlabeltobags:
          "Attach your stickers by pressing them firmly onto your bags.",
        dropindroparea: "Express Bag Drop",
        placeindesignatedarea: "Drop off your bags in the express return area.",
        thatsit: "You have finished!",
        refundcredited:
          "You will receive the credit in your account within %{count} days.",
        refundcredited_1:
          "You will receive the credit in your account within %{count} day.",
        finish: "Finish"
      },
      errorscreen: {
        error: "Error",
        errorhasoccured: "Kiosk is connected to an invalid collector.",
        contactoperator:
          "Please enter a valid kiosk key or contact technical support."
      },
      printerdebug: {
        printtestlabel: "Print Test Label",
        returntoconfigure: "Return To Configure"
      },
      theme: {}
    },
    date: {
      long: "MMMM do, yyyy"
    },
    export: "Export %{count} items",
    export_0: "Nothing to export",
    export_1: "Export %{count} item",
    two_lines: "<div>Line 1<br />Line 2</div>"
  },
  fr: {
    application: {
      title: "Application géniale avec i18n!",
      hello: "Bonjour, %{name}!",
      welcome: "Bienvenue, %{name}!",
      thanks: "Merci, %{name}!",
      next: "suivant",
      back: "Retour",
      end: "Fin",
      no: "Non",
      yes: "Oui",
      close: "Fermer",
      continue: "Continuer",
      success: "Réussi",
      options: {
        androidpluginunavailable: "Plugin Android non disponible",
        epsonprinterpluginunavailable: "Plugin Epson non disponible",
        invalidcode: "Code invalide",
        toomanyrequest: "Veuillez réessayer dans une minute"
      },
      errors: {
        serverunavailable: "Serveur temporairement indisponible.",
        webaccessdisabled: "L'accès Web est désactivé.",
        unknownerror: "Une erreur inconnue s'est produite.",
        invalidcredentials:
          "Informations d'identification non valides fournies.",
        toomanyrequests:
          "Trop de demandes incorrectes. SVP réessayez dans une minute."
      },
      kioskdetail: {
        youareat: "Vous êtes à %{name} situé sur %{address}",
        youareatV: "Vous êtes situé au %{address}",
        returningnumbags_1: "Vous retournez %{count} sac.",
        returningnumbags: "Vous retournez %{count} sacs.",
        returningnumlabels_1: "Vous imprimez %{count} autocollant.",
        returningnumlabels: "Vous imprimez %{count} autocollants.",
        returning: "Vous retournez ",
        numbags_1: "%{count} sac",
        numbags: "%{count} sacs",
        print: "imprimant",
        numlabels_1: "%{count} autocollant.",
        numlabels: "%{count} autocollants.",
        errors: {
          unabletoprocesskey:
            "Une erreur s'est produite lors du traitement de votre clé de kiosque.",

          keyerror:
            "Une erreur s'est produite lors du traitement de votre clé de kiosque. Veuillez vérifier votre clé de kiosque."
        }
      },
      configuration: {
        configuration: "Configuration",
        donthavekioskkey: "Vous n'avez pas de clé de kiosque?",
        enterkey: "Veuillez entrer la clé du kiosque pour commencer",
        printerdebug: "Débogage de l'imprimante",
        confirmlogginginas: "Vous enregistrez cet appareil pour :",
        warning: "Avertissement ",
        confirmchangecollectorwarning:
          "Cet appareil était précédemment enregistré pour ",
        confirmisthiscorrect: "Est-ce exact ?",
        versionmismatch: "Mise à jour logicielle requise",
        versionmismatchwarning:
          "L'application du kiosque installée (v%{currentversion}) est désuète. La version la plus récente est la v%{latestversion}. Veuillez effectuer la mise à jour avant de continuer, ou appuyez sur « Continuer » pour poursuivre sans mettre à jour."
      },
      languageselect: {
        kioskname: "Retour Express Dépôt de sacs",
        presstostart: "Appuyez ici pour débuter",
        selectlanguage: "Veuillez sélectionner une langue:",
        english: "English",
        french: "Français",
        quickstart: "Début rapide",
        scanwithapp:
          "Identifiez-vous rapidement en balayant le code QR avec l’application Consignaction."
        // scanwithapp:
        //   "Scannez le code QR à l'aide de l'application Consignaction pour commencer"
      },
      adminoptions: {
        kioskid: "ID de kiosque",
        androidid: "ID Android",
        testtheme: "Thème de test",
        printercut: "Coupe d'imprimante",
        accesscoderequired: "Code d'accès requis",
        instructions: "Entrez le code administrateur",
        optionmenutitle: "Options du Kiosque"
      },
      phonenumber: {
        enterphonenumber: "Entrez votre numéro de téléphone",
        pleasesignin: "Connectez-vous avec votre numéro de téléphone.",
        welcome: "Bienvenue!",
        donthaveaccount: "Vous n'avez pas de compte?",
        signinwithphone: "Entrez votre numéro de téléphone",
        scanqr:
          "Balayez le code QR pour télécharger l’application mobile et créer un compte",
        returnfor: "Vous retournez des sacs pour:",
        isthiscorrect: "Est-ce correct?",
        urllangextension: "?lang=fr",
        enterslowly: "Veuillez entrer votre numéro doucement",
        errors: {
          unablefetchaccount:
            "Une erreur s'est produite lors de la récupération de votre compte.",
          invalidphone: "Numéro de téléphone invalide. Veuillez réessayer."
        }
      },
      numberofbags: {
        selectnumbags: "Combien de sacs retournez-vous?",
        havemorebags: "Avez-vous plus de %{count} sacs?",
        multipleinteractions:
          "Oui. Vous devrez effectuer plus d’une transaction.",
        needonlybags: "Avez-vous simplement besoin d’autocollants?",
        selectzerobags: "Oui. Veuillez sélectionner 0 sacs."
      },
      numberoflabels: {
        instructions:
          "Pour vous assurer d'être crédité, joignez une étiquette sur chaque sac.",
        selectnumlabels: "Combien d’autocollants voulez-vous imprimer?",
        bagsalreadylabelled: "Avez-vous des sacs déjà identifiés?",
        selectzerobags: "Oui. Veuillez sélectionner 0.",
        cantakelabelshome: "Pouvez-vous emporter des étiquettes à la maison?",
        uselabelsnexttime:
          "Oui, utilisez-les la prochaines fois pour accélérer le dépôt."
      },
      submissionapproval: {
        title: "Un instant — Intervention du personnel requise",
        instructions_1:
          "Un gestionnaire doit approuver votre retour de %{count} sac avant de continuer.",
        instructions:
          "Un gestionnaire doit approuver votre retour de %{count} sacs avant de continuer.",
        errors: {
          overridekeyerror:
            "Code invalide. Veuillez vérifier votre code et essayez encore."
        }
      },
      printing: {
        printing: "Les étiquettes sont en cours d'impression",
        readytoprint: "Prêt à imprimer",
        taptoprint: "Cliquez ici pour imprimer"
      },
      printererror: {
        title: "Erreur d'imprimante",
        notconnected:
          "L'imprimante n'est pas connectée. Assurez-vous qu'elle est allumée et vérifiez le câble de l'imprimante.",
        coveropen:
          "Le couvercle de l'imprimante est ouvert. Veuillez le fermer pour continuer.",
        generalerror:
          "Nous avons détecté un problème avec l'imprimante. Votre imprimante manque peut-être de papier—veuillez vérifier et recharger au besoin.",
        recheckbutton: "Revérifier"
      },
      thankyou: {
        thankyou: "Merci!",
        seeyouagain: "Nous espérons vous revoir bientôt, %{name}!",
        labelyourbags: "Identifiez vos sacs",
        attachlabeltobags:
          "Apposez vos autocollants en les appuyant fermement sur vos sacs.",
        dropindroparea: "Dépôt de sac",
        placeindesignatedarea:
          "Déposez vos sacs dans la zone du retour express.",
        thatsit: "Vous avez terminé!",
        refundcredited:
          "Vous recevrez le crédit dans votre compte d’ici %{count} jours.",
        refundcredited_1:
          "Vous recevrez le crédit dans votre compte d’ici %{count} jour.",
        finish: "Terminer"
      },
      errorscreen: {
        error: "Erreur",
        errorhasoccured: "Le kiosque est connecté à un collecteur non valide.",
        contactoperator:
          "Veuillez saisir une clé de kiosque valide ou contacter le support technique."
      },
      printerdebug: {
        printtestlabel: "Imprimer l'étiquette de test",
        returntoconfigure: "Retour à la configuration"
      },
      theme: {}
    },
    date: {
      long: "d MMMM yyyy"
    },
    export: "Exporter %{count} éléments",
    export_0: "Rien à exporter",
    export_1: "Exporter %{count} élément",
    two_lines: "<div>Regel 1<br />Regel 2</div>"
  }
};

export const initializeTranslations = async (url, params) => {
  setTranslations(translations, true);

  setLocale("fr");
};

export const syncInitializeTranslations = () => {
  setTranslations(translations, true);
};

export const addThemeTranslation = (key, french, english) => {
  console.log(
    "[addThemeTranslation] key, french, english",
    key,
    french,
    english
  );

  console.log("[addThemeTranslation] translations", translations);

  translations.en.application.theme[key] = english;
  translations.fr.application.theme[key] = french;
};

export const debugPrintTranslations = () => {
  console.log(translations);
};
